module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap1"
    }
  }, [_vm._v("Beginning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap2"
    }
  }, [_vm._v("Casualties")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap3"
    }
  }, [_vm._v("Refugees")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap4"
    }
  }, [_vm._v("The Boy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap5"
    }
  }, [_vm._v("The River")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap6"
    }
  }, [_vm._v("The Stones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap7"
    }
  }, [_vm._v("The Crannog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap8"
    }
  }, [_vm._v("Drust")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap9"
    }
  }, [_vm._v("Potential")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap10"
    }
  }, [_vm._v("An Uninvited Guest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap11"
    }
  }, [_vm._v("Children of The Dark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap12"
    }
  }, [_vm._v("Family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap13"
    }
  }, [_vm._v("The Source")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap14"
    }
  }, [_vm._v("The Emigrants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap15"
    }
  }, [_vm._v("The Geis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap16"
    }
  }, [_vm._v("Old Creatures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap17"
    }
  }, [_vm._v("Taming The Wild")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap18"
    }
  }, [_vm._v("The Final Day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap19"
    }
  }, [_vm._v("The World Beneath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap20"
    }
  }, [_vm._v("The Sacrifice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap21"
    }
  }, [_vm._v("Escape")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_chap22"
    }
  }, [_vm._v("Full Circle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "teas-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Bec_teas2"
    }
  }, [_vm._v("A Preview of \"BLOOD BEAST\"")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baa0e55a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bec_toc.vue
// module id = 60
// module chunks = 0